import { createApi } from '@reduxjs/toolkit/query/react';

import { customBaseQuery } from '@app/services/rtkQuery/baseQuery';
import { Methods } from '@app/services/rtkQuery/types';
import type { WithActiveBranchId, NAuth, NRecordReminders } from '@app/types';

enum Endpoints {
  GetRecordReminders = 'GetRecordReminders',
  SetRecordReminders = 'SetRecordReminders',
  DeleteRecordReminders = 'DeleteRecordReminders',
  AttachFiles = 'AttachFiles',
  RemoveFiles = 'RemoveFiles',
  GetFiles = 'GetFiles',
}
export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: ({ url, ...props }) =>
    customBaseQuery({ url: `/RecordReminders/${url}`, ...props }),
  endpoints: ({ query, mutation }) => ({
    [Endpoints.GetRecordReminders]: query<
      NRecordReminders.ModelBranchRecordReminders,
      {
        params: {
          ActiveBranchId: NAuth.UserPrint['activeBranchId'];
        };
      }
    >({
      query: ({ params }) => ({
        url: Endpoints.GetRecordReminders,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.SetRecordReminders]: mutation<
      NRecordReminders.ModelBranchRecordReminders,
      {
        params: {
          ActiveBranchId: NAuth.UserPrint['activeBranchId'];
        };
        data: NRecordReminders.ModelBranchRecordReminders;
      }
    >({
      query: ({ params, data }) => ({
        url: Endpoints.SetRecordReminders,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.DeleteRecordReminders]: mutation<void, WithActiveBranchId>({
      query: (params) => ({
        url: Endpoints.DeleteRecordReminders,
        method: Methods.DELETE,
        params,
      }),
    }),
    [Endpoints.AttachFiles]: mutation<
      NRecordReminders.ModelRecordReminder,
      WithActiveBranchId<NRecordReminders.ModelAttachFilesToReminder>
    >({
      query: ({ ActiveBranchId, ...data }) => ({
        url: Endpoints.AttachFiles,
        method: Methods.POST,
        params: { ActiveBranchId },
        data,
      }),
    }),
    [Endpoints.RemoveFiles]: mutation<
      void,
      WithActiveBranchId<NRecordReminders.ModelRemoveFilesFromReminder>
    >({
      query: ({ ActiveBranchId, ...data }) => ({
        url: Endpoints.RemoveFiles,
        method: Methods.POST,
        params: { ActiveBranchId },
        data,
      }),
    }),
    [Endpoints.GetFiles]: mutation<
      NRecordReminders.ModelFilesByReminder,
      WithActiveBranchId<NRecordReminders.ModelGetReminderFiles>
    >({
      query: ({ ActiveBranchId, ...data }) => ({
        url: Endpoints.GetFiles,
        method: Methods.POST,
        params: { ActiveBranchId },
        data,
      }),
    }),
  }),
});

export const {
  useAttachFilesMutation,
  useDeleteRecordRemindersMutation,
  useGetRecordRemindersQuery,
  useLazyGetRecordRemindersQuery,
  useRemoveFilesMutation,
  useSetRecordRemindersMutation,
  useGetFilesMutation,
} = notificationsApi;
